<template>
  <a-layout class="layout">
  <div class="loginformClass">
    <a-upload
      :file-list="fileList"
      :remove="handleRemove"
      :before-upload="beforeUpload"
    >
      <a-button> <a-icon type="upload" /> 选择文件 </a-button>
    </a-upload>
    <a-button
      type="primary"
      :disabled="fileList.length === 0"
      :loading="uploading"
      style="margin-top: 16px"
      @click="handleUpload"
    >
      {{ uploading ? "上传" : "开始上传" }}
    </a-button>
  </div>
  </a-layout>
</template>
<script>
import XLSX from "xlsx";
import {jsonExport,arrayExport} from '../js/xlsxTool';
export default {
  data() {
    return {
      fileList: [],
      uploading: false,
    };
  },
  methods: {
    isExcel(file) {
      return /\.(xlsx|xls)$/.test(file.name);
    },
    handleRemove(file) {
      const index = this.fileList.indexOf(file);
      const newFileList = this.fileList.slice();
      newFileList.splice(index, 1);
      this.fileList = newFileList;
    },
    beforeUpload(file) {
      if (!this.isExcel(file)) {
        this.$message.error("仅支持上传.xlsx、.xls、后缀文件");
        return false;
      }
      this.fileList = [file];
      return false;
    },
    handleUpload() {
      this.uploading = true;
      const that = this;
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          const data = e.target.result;
          const workbook = XLSX.read(data, { type: "array" });
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];
          const header = that.getHeaderRow(worksheet);
          const results = XLSX.utils.sheet_to_json(worksheet);
          this.generateData({ header, results })
          resolve();
        };
        reader.readAsArrayBuffer(that.fileList[0]);
      });
    },
    generateData({ header, results }) {
      //进行上传
      this.uploading = false;
      this.fileList = [];
    },
    getHeaderRow(sheet) {
      const headers = [];
      const range = XLSX.utils.decode_range(sheet["!ref"]);
      let C;
      const R = range.s.r;
      for (C = range.s.c; C <= range.e.c; ++C) {
        const cell = sheet[XLSX.utils.encode_cell({ c: C, r: R })];
        let hdr = "UNKNOWN " + C;
        if (cell && cell.t) hdr = XLSX.utils.format_cell(cell);
        headers.push(hdr);
      }
      return headers;
    },
    fileExport() {
      var aoa = [
        ["姓名", "性别", "年龄", "注册时间"],
        ["张三", "男", 18, new Date()],
        ["李四", "女", 22, new Date()],
      ];
      arrayExport(aoa,"array导出");
      var aoa2 = [
        {n:"姓名",s:"性别",a:"年龄",t:"注册时间"},
        {n:"张三", s:"男", a:18, t:new Date()},
        {n:"李四", s:"女", a:22, t:new Date()}
      ];
      jsonExport(aoa2,"json导出");
    },
  },
};
</script>
<style>
.layout {
  background-size: 100% 100%;
  height: 100vh;
}

.loginformClass {
  background: #fff;
  border: 3px solid #fff;
  border-radius: 5px;
  width: 40%;
  position: relative;
  margin: 0 auto;
  padding: 5% 0 5% 5%;
  top: 50%;
  transform: translateY(-50%);
}
</style>



// WEBPACK FOOTER //
// src/components/template.vue